// JsFromRoutes CacheKey 42fc6abf131877c13958df57025d57b3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/exports"),
}
